"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1782],{

/***/ 81782:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69587);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _mobile_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(73223);
/* harmony import */ var _mobile_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_mobile_module_scss__WEBPACK_IMPORTED_MODULE_5__);






var Collapse = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function() {
    return __webpack_require__.e(/* import() */ 2142).then(__webpack_require__.bind(__webpack_require__, 12142));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(12142)
            ];
        }
    }
});
function MobileLinksForPages(props) {
    var links = props.links, _level = props.level, level = _level === void 0 ? 0 : _level, onItemClick = props.onItemClick;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    var realPath = router.locale !== "catchAll" ? router.locale + "/" : "";
    var handleItemClick = function(item) {
        if (onItemClick) {
            onItemClick(item);
        }
    };
    var makeTargetBlank = function(link, new_tab, href, toggle) {
        if (new_tab) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                rel: "noreferrer",
                href: href,
                target: "_blank",
                className: (_mobile_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["mobile-links__item-link"]),
                onClick: function() {
                    handleItemClick(link);
                    toggle();
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                    type: "button",
                    className: (_mobile_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["mobile-links__item-link"]),
                    onClick: function() {
                        handleItemClick(link);
                        toggle();
                    },
                    children: [
                        link.name,
                        " "
                    ]
                })
            });
        } else {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                href: href,
                className: (_mobile_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["mobile-links__item-link"]),
                onClick: function() {
                    handleItemClick(link);
                    toggle();
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                    type: "button",
                    className: (_mobile_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["mobile-links__item-link"]),
                    onClick: function() {
                        handleItemClick(link);
                        toggle();
                    },
                    children: [
                        link.name,
                        " "
                    ]
                })
            });
        }
    };
    var linksList = links.map(function(link, index) {
        var item;
        item = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Collapse, {
            //   @ts-ignore
            toggleClass: (_mobile_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["mobile-links__item--open"]),
            //   @ts-ignore
            render: function(param) {
                var toggle = param.toggle, setItemRef = param.setItemRef, setContentRef = param.setContentRef;
                var arrow;
                var subLinks;
                var linkOrButton;
                if (link.type != "header" && link.type != "footer") link.type = "link";
                if (link.childs && link.childs.length > 0 || link.children && link.children.length > 0) {
                    arrow = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                        className: (_mobile_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["mobile-links__item-toggle"]),
                        type: "button",
                        onClick: toggle,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_svg__WEBPACK_IMPORTED_MODULE_2__/* .ArrowRoundedDown12x7Svg */ .bD, {
                            className: (_mobile_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["mobile-links__item-arrow"])
                        })
                    });
                    subLinks = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_mobile_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["mobile-links__item-sub-links"]),
                        ref: setContentRef,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(MobileLinksForPages, {
                            /*@ts-ignore*/ links: link.childs || link.children,
                            level: level ? level + 1 : 1,
                            onItemClick: onItemClick
                        })
                    });
                }
                if (link.type == "button") {
                    linkOrButton = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                        type: "button",
                        className: (_mobile_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["mobile-links__item-link"]),
                        onClick: function() {
                            handleItemClick(link);
                        },
                        children: link.name || link.label
                    });
                } else {
                    var href = "";
                    if (link.type !== "link") {
                        if (link.url_key) {
                            href = link.url_key;
                        } else {
                            href = "/".concat(realPath, "page/").concat(link.slug);
                        }
                    }
                    linkOrButton = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                className: (_mobile_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["link-label-fms"]),
                                onClick: toggle,
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_svg__WEBPACK_IMPORTED_MODULE_2__/* .PagesSVG */ .F2, {}),
                                    link.label
                                ]
                            }),
                            makeTargetBlank(link, link.new_tab, href, toggle)
                        ]
                    });
                }
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "".concat((_mobile_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["mobile-links__item"]), " ").concat(link.id === 1 && (_mobile_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["mobile-links__item--open"])),
                    ref: setItemRef,
                    children: [
                        link.id === 1 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {}) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_mobile_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["mobile-links__item-title"]),
                            children: [
                                linkOrButton,
                                arrow
                            ]
                        }),
                        subLinks
                    ]
                });
            }
        });
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
            children: item
        }, index);
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
        className: "".concat((_mobile_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["mobile-links"]), " ").concat((_mobile_module_scss__WEBPACK_IMPORTED_MODULE_5___default())["mobile-links--level--".concat(level)]),
        children: linksList
    });
}
/* harmony default export */ __webpack_exports__["default"] = (MobileLinksForPages);


/***/ })

}]);